import type { ReactNode } from "react";
import { Info } from "lucide-react";

export interface SigningHintProps {
  children: ReactNode;
  /** Optional shortcut to where the missing step is done. */
  action?: { label: string; onClick: () => void };
}

/**
 * A short plain-language note about what a document is still waiting for.
 * Presentational only — the pages decide when to show it, and it never
 * replaces the buttons that actually perform the step.
 */
export default function SigningHint({ children, action }: SigningHintProps) {
  return (
    <div
      role="note"
      className="flex items-start gap-2 rounded-md bg-amber-50 p-3 text-sm text-amber-900"
    >
      <Info className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
      <div>
        <p>{children}</p>
        {action && (
          // 44px high on a phone and on a touch screen, where a 20px line of text is too small to tap.
          <button
            type="button"
            onClick={action.onClick}
            className="mt-1 inline-flex items-center font-medium underline max-md:min-h-11 [@media(pointer:coarse)]:min-h-11"
          >
            {action.label}
          </button>
        )}
      </div>
    </div>
  );
}
